import { EventEmitter, Injectable } from '@angular/core';
import { AvailableLocales, defaultLocale } from '../entities/config';
import { Observable } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class LocaleService {
    private readonly _onLocaleChange$ = new EventEmitter<AvailableLocales>();
    private _currentLocale = defaultLocale;

    constructor(private readonly translocoService: TranslocoService) {
        this.translocoService.setActiveLang(this._currentLocale);
    }

    get onLocaleChange(): Observable<AvailableLocales> {
        return this._onLocaleChange$;
    }

    get currentLocale(): AvailableLocales {
        return this._currentLocale;
    }

    changeLocale(locale: AvailableLocales): void {
        this._currentLocale = locale;
        this._onLocaleChange$.emit(locale);
    }
}
